// AUTOGENERATED
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dNumber from "../Data.Number/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dGeneric from "../Foreign.Generic/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $Tip = _1 => ({tag: "Tip", _1});
const TipIsSymbol = {reflectSymbol: () => "Tip"};
const Tip = value0 => $Tip(value0);
const toFillFormTypeTip = {fillFormDataType: v => "unknown"};
const eqTip = {eq: x => y => x._1 === y._1};
const genericTip = {to: x => $Tip(x), from: x => x._1};
const showTip = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dMoney$dRounded.toString(v)]})(TipIsSymbol);
    return x => $0["genericShow'"](x._1);
  })()
};
const unscrambleDecodeTip = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dGeneric.genericUnsafeDecodeTagged(genericTip)(/* #__PURE__ */ Unscramble$dGeneric.genericDecodeSumConstruct(TipIsSymbol)({
    unsafeDecodeSingleConstructorArgument: x => Data$dInt.unsafeClamp(Data$dNumber.round(Unscramble.decodeNumber(x.contents) * 100.0))
  }))(Unscramble$dGeneric.defaultOptions)
};
const encodingOptsTip = {...Foreign$dGeneric$dClass.defaultOptions, unwrapSingleConstructors: true, unwrapSingleRecordArguments: true};
const encodeTip = {
  encode: /* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(TipIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", Data$dInt.toNumber(v) / 100.0), Data$dList$dTypes.Nil)
    }).encodeOpts({...encodingOptsTip, unwrapSingleConstructors: false});
    return x => $0(x._1);
  })()
};
const decodeTip = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericTip)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(TipIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))({...encodingOptsTip, unwrapSingleConstructors: false})
};
export {$Tip, Tip, TipIsSymbol, decodeTip, encodeTip, encodingOptsTip, eqTip, genericTip, showTip, toFillFormTypeTip, unscrambleDecodeTip};
